import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "testing-take-sticky"
}
const _hoisted_2 = { class: "liga-float-bar testing-take-float-bar" }
const _hoisted_3 = { class: "liga-float-title-pill" }
const _hoisted_4 = { class: "liga-float-title-text" }
const _hoisted_5 = {
  key: 0,
  class: "testing-take-header"
}
const _hoisted_6 = {
  key: 0,
  class: "testing-take-desc"
}
const _hoisted_7 = ["data-tick"]
const _hoisted_8 = { class: "testing-timer-label" }
const _hoisted_9 = {
  key: 0,
  class: "testing-timer-remaining"
}
const _hoisted_10 = { class: "testing-list-wrap" }
const _hoisted_11 = {
  key: 0,
  class: "testing-hint"
}
const _hoisted_12 = {
  key: 1,
  class: "testing-hint"
}
const _hoisted_13 = {
  key: 2,
  class: "testing-list"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "testing-card-icon" }
const _hoisted_16 = { class: "testing-card-body" }
const _hoisted_17 = { class: "testing-card-title" }
const _hoisted_18 = {
  key: 0,
  class: "testing-card-desc"
}
const _hoisted_19 = { class: "testing-card-meta" }
const _hoisted_20 = {
  key: 0,
  class: "testing-status testing-status--passed"
}
const _hoisted_21 = {
  key: 1,
  class: "testing-status testing-status--scheduled"
}
const _hoisted_22 = {
  key: 2,
  class: "testing-status testing-status--open"
}
const _hoisted_23 = {
  key: 3,
  class: "testing-status testing-status--used"
}
const _hoisted_24 = {
  key: 4,
  class: "testing-score"
}
const _hoisted_25 = {
  key: 1,
  class: "testing-take-wrap"
}
const _hoisted_26 = {
  key: 0,
  class: "testing-take-loading"
}
const _hoisted_27 = {
  key: 1,
  class: "testing-take-questions"
}
const _hoisted_28 = { class: "testing-question-text" }
const _hoisted_29 = {
  key: 0,
  class: "testing-answers"
}
const _hoisted_30 = ["onClick", "onKeydown"]
const _hoisted_31 = { class: "testing-answer-label ion-text-wrap" }
const _hoisted_32 = ["onClick", "onKeydown"]
const _hoisted_33 = { class: "ion-text-wrap testing-answer-label" }
const _hoisted_34 = {
  key: 2,
  class: "testing-take-actions"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageHeaderWithMenu = _resolveComponent("PageHeaderWithMenu")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_refresher_content = _resolveComponent("ion-refresher-content")!
  const _component_ion_refresher = _resolveComponent("ion-refresher")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_checkbox = _resolveComponent("ion-checkbox")!
  const _component_ion_radio = _resolveComponent("ion-radio")!
  const _component_ion_radio_group = _resolveComponent("ion-radio-group")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _withDirectives(_createVNode(_component_PageHeaderWithMenu, {
        title: "Тестирование",
        scrolled: _ctx.headerScrolled
      }, null, 8, ["scrolled"]), [
        [_vShow, !_ctx.currentTest]
      ]),
      (_ctx.currentTest)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("button", {
                type: "button",
                class: "liga-float-circle",
                "aria-label": "К списку тестов",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeTest && _ctx.closeTest(...args)))
              }, [
                _createVNode(_component_ion_icon, { icon: _ctx.chevronBackOutline }, null, 8, ["icon"])
              ]),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.currentTest.name), 1)
              ]),
              _cache[2] || (_cache[2] = _createElementVNode("div", {
                class: "liga-float-spacer",
                "aria-hidden": "true"
              }, null, -1))
            ]),
            (_ctx.currentTest.description || _ctx.attemptStartedAt)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (_ctx.currentTest.description)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.currentTest.description), 1))
                    : _createCommentVNode("", true),
                  (_ctx.attemptStartedAt)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "testing-timer-wrap",
                        "data-tick": _ctx.timerTick
                      }, [
                        _createElementVNode("span", _hoisted_8, "Время: " + _toDisplayString(_ctx.timerElapsed), 1),
                        (_ctx.currentTest.timeLimitMinutes != null)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.timeExpired ? 'Время вышло' : `Осталось: ${_ctx.timerRemaining}`), 1))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_7))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_ion_content, {
        class: _normalizeClass([_ctx.isMobile ? 'main-background' : 'liga-web-background', 'testing-content']),
        fullscreen: true,
        onIonScroll: _ctx.onContentScroll
      }, {
        default: _withCtx(() => [
          (!_ctx.currentTest)
            ? (_openBlock(), _createBlock(_component_ion_refresher, {
                key: 0,
                slot: "fixed",
                onIonRefresh: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadMyTests($event)))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_refresher_content, { refreshingSpinner: "bubbles" })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("div", _hoisted_10, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("p", _hoisted_11, "Загрузка…"))
              : (!_ctx.myTests.length)
                ? (_openBlock(), _createElementBlock("p", _hoisted_12, "Вам пока не назначены тесты."))
                : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.myTests, (t) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: t.id,
                        class: _normalizeClass([
              'testing-card',
              {
                'testing-card--passed': t.passed,
                'testing-card--locked': !t.passed && !_ctx.canOpenTest(t),
              },
            ]),
                        onClick: ($event: any) => (_ctx.onTestCardClick(t))
                      }, [
                        _createElementVNode("div", _hoisted_15, [
                          _createVNode(_component_ion_icon, { icon: _ctx.documentTextOutline }, null, 8, ["icon"])
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("h3", _hoisted_17, _toDisplayString(t.name), 1),
                          (t.description)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(t.description), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_19, [
                            (t.passed)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                                  _createVNode(_component_ion_icon, { icon: _ctx.checkmarkCircle }, null, 8, ["icon"]),
                                  _cache[3] || (_cache[3] = _createTextVNode(" Пройден ", -1))
                                ]))
                              : (!_ctx.isTestAvailableLocally(t) && !t.hasDraft)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                                    _createTextVNode(" Откроется " + _toDisplayString(_ctx.formatAvailableFrom(t.availableFrom)) + " ", 1),
                                    (_ctx.availabilityCountdownSec[t.id] > 0)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createTextVNode(" · " + _toDisplayString(_ctx.formatCountdown(_ctx.availabilityCountdownSec[t.id])), 1)
                                        ], 64))
                                      : _createCommentVNode("", true)
                                  ]))
                                : (t.attemptsLeft)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_22, "Доступен"))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_23, "Попытки исчерпаны")),
                            (t.lastScore != null)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_24, "Результат: " + _toDisplayString(t.lastScore) + "%", 1))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createVNode(_component_ion_icon, {
                          icon: _ctx.chevronForwardOutline,
                          class: "testing-card-arrow"
                        }, null, 8, ["icon"])
                      ], 10, _hoisted_14))
                    }), 128))
                  ]))
          ], 512), [
            [_vShow, !_ctx.currentTest]
          ]),
          (_ctx.currentTest)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                (_ctx.testLoading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _createVNode(_component_ion_spinner, { name: "bubbles" })
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.currentTest.questions || []), (q) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: q.id,
                          class: "testing-question-block"
                        }, [
                          _createElementVNode("p", _hoisted_28, _toDisplayString(q.text), 1),
                          (q.multipleChoice)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(q.answers, (a) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: a.id,
                                    class: "testing-answer-row",
                                    role: "button",
                                    tabindex: "0",
                                    onClick: ($event: any) => (_ctx.toggleAnswer(q.id, a.id)),
                                    onKeydown: _withKeys(_withModifiers(($event: any) => (_ctx.toggleAnswer(q.id, a.id)), ["prevent"]), ["enter","space"])
                                  }, [
                                    _createVNode(_component_ion_checkbox, {
                                      checked: _ctx.isSelected(q.id, a.id),
                                      tabindex: "-1"
                                    }, null, 8, ["checked"]),
                                    _createElementVNode("span", _hoisted_31, _toDisplayString(a.text), 1)
                                  ], 40, _hoisted_30))
                                }), 128))
                              ]))
                            : (_openBlock(), _createBlock(_component_ion_radio_group, {
                                key: 1,
                                value: (_ctx.selectedAnswers[q.id] || [])[0],
                                onIonChange: ($event: any) => (_ctx.onSingleChange(q.id, $event)),
                                class: "testing-answers"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((q.answers || []), (a) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: a.id,
                                      class: "testing-answer-row",
                                      role: "button",
                                      tabindex: "0",
                                      onClick: ($event: any) => (_ctx.selectSingleAnswer(q.id, a.id)),
                                      onKeydown: _withKeys(_withModifiers(($event: any) => (_ctx.selectSingleAnswer(q.id, a.id)), ["prevent"]), ["enter","space"])
                                    }, [
                                      _createVNode(_component_ion_radio, {
                                        value: a.id,
                                        "label-placement": "end",
                                        "aria-label": a.text,
                                        tabindex: "-1"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("span", _hoisted_33, _toDisplayString(a.text), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["value", "aria-label"])
                                    ], 40, _hoisted_32))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1032, ["value", "onIonChange"]))
                        ]))
                      }), 128))
                    ])),
                (_ctx.currentTest && !_ctx.testLoading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                      _createVNode(_component_ion_button, {
                        expand: "block",
                        class: "admin-primary-btn",
                        onClick: _ctx.submitTest,
                        disabled: _ctx.submitting || _ctx.timeExpired
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.submitting ? 'Отправка…' : 'Завершить тест'), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick", "disabled"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["class", "onIonScroll"])
    ]),
    _: 1
  }))
}